import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
//import ImageWithBasePath from "../../img/imagewithbasepath"; // Corrected the import path typo
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import countriesData from '../../json/countries.json'; 
import axios from "axios";
import { set_page_refresh } from "../../redux/action";

const AddSupplierModal = () => {
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const choose = t?.[l]?.["choose"] || "Choose";
  const [supplier, setSupplier] = useState({ country: "" });
  const closeRef = useRef(null);
  const closeRef2 = useRef(null);
  const countriesOptions = countriesData;
  // [
  //   { value: "", label: choose, name: "Choose" },
  //   { value: "Kuwait", label: t?.[l]?.["kuwait"] || "Kuwait", name: "Kuwait" },
  // ];

  useEffect(() => {
    const handleHidden = () => {
      setSupplier({ country: "" });
    };

    const modalElement = document.getElementById("add-units");
    modalElement?.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, []);


  const submit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    try {
      if (form?.checkValidity()) {
        let result = await axios.post("addsupplier/", supplier);
        document.querySelector(".modal-backdrop").classList.toggle("show");
        dispatch(set_page_refresh("suppliers"));
        setSupplier({ country: "" });
        form.reset();
        closeRef.current?.click();
        closeRef2.current?.click();
        console.log(result);
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    }

    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSupplier((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div>
      {/* Add Supplier */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t?.[l]?.["add_supplier"] || "Add Supplier"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-12 hidden">
                        <div className="new-employee-field">
                          <span>Avatar</span>
                          <div className="profile-pic-upload mb-2">
                            <div className="profile-pic">
                              <span>
                                <i
                                  data-feather="plus-circle"
                                  className="plus-down-add"
                                />{" "}
                                Profile Photo
                              </span>
                            </div>
                            <div className="input-blocks mb-0">
                              <div className="image-upload mb-0">
                                <input type="file" />
                                <div className="image-uploads">
                                  <h4>Change Image</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["supplier_name"] || "Supplier Name"}</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            name="name"
                            value={supplier.name || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["email"] || "Email"}</label>
                          <input
                            type="email"
                            className="form-control"
                            required
                            name="email"
                            value={supplier.email || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["phone"] || "Phone"}</label>
                          <input
                            type="text"
                            className="form-control"
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/\D/g, "");
                            }}
                            maxLength={15}
                            required
                            name="contactNo"
                            value={supplier.contactNo || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["address"] || "Address"}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={supplier.address || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["city"] || "City"}</label>
                          <input
                            type="text"
                            name="city"
                            value={supplier.city || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-10 col-10">
                        <div className="input-blocks">
                          <label>{t?.[l]?.["country"] || "Country"}</label>
                          <Select
                            className="select"
                            options={countriesOptions}
                            name="country"
                            placeholder={choose}
                            value={countriesOptions.find(option => option.value === supplier.country)}
                            onChange={(v) => {
                              handleInputChange({ target: { name: "country", value: v.value } });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0 input-blocks">
                          <label className="form-label">{t?.[l]?.["descriptions"] || "Descriptions"}</label>
                          <textarea
                            className="form-control mb-1"
                            maxLength={1000}
                            name="description"
                            value={supplier.description || ""}
                            onChange={handleInputChange}
                          />
                          <p>{t?.[l]?.["maximum_1000_characters"] || "Maximum 1000 Characters"}</p>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t?.[l]?.["cancel"] || "Cancel"}
                      </button>
                      <button type="submit" className="btn btn-submit">
                        {t?.[l]?.["save"] || "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Supplier */}
    </div>
  );
};

export default AddSupplierModal;
